import React from "react";

export default function CarVideo({ video, muted, onPlay }) {
  const [alreadyPlay, setAlreadyPlay] = React.useState(false);

  React.useEffect(() => {
    setAlreadyPlay(false);
  }, [video]);

  const handlePlay = () => {
    if (alreadyPlay) return;
    setAlreadyPlay(true);
    onPlay();
  };

  return (
    <video key={video} controls onPlay={handlePlay}>
      <source src={video} />
    </video>
  );
}
